import { render, staticRenderFns } from "./RipaSchoolsGrid.vue?vue&type=template&id=64e170de"
import script from "./RipaSchoolsGrid.vue?vue&type=script&lang=js"
export * from "./RipaSchoolsGrid.vue?vue&type=script&lang=js"
import style0 from "./RipaSchoolsGrid.vue?vue&type=style&index=0&id=64e170de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports